import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getEnvVariables } from '../../helpers/getEnvVariables';
const { REACT_APP_URL } = getEnvVariables();

export const usersApi = createApi({
    reducerPath: 'users',
    baseQuery: fetchBaseQuery({
        baseUrl: REACT_APP_URL,
        prepareHeaders: (headers, { getState, endpoint }) => {
            const token = JSON.parse(localStorage.getItem('user')!)?.token;
            const excludedEndpoints = ['verifyEmail', 'sendVerifyCode', 'verifyCode', 'reactivateUser'];
            if (token && !excludedEndpoints.includes(endpoint)) headers.set('Authorization', token);
            headers.set('Content-Type', 'application/json');
            return headers;
        },
        responseHandler: async (response) => {
            const data = await response.json();
            return {
                ...data,
                meta: {
                    status: response.status,
                },
            };
        },
    }),

    endpoints: (builder) => ({
        updateUser: builder.mutation({
            query: (data) => ({
                url: `customer/${data._id}`,
                method: 'PUT',
                body: data,
            }),
        }),
        validateUsername: builder.query({
            query: (username: string) => ({
                url: `customer/validate/username/${username}`,
                method: 'GET',
            }),
        }),
        updateImg: builder.mutation({
            query: (data) => ({
                url: `customer/update/img/${data._id}`,
                method: 'PUT',
                body: { img: data.img },
            }),
        }),
        verifyEmail: builder.query({
            query: (email: string) => ({
                url: `customer/verify/byEmail/${email}`,
                method: 'GET',
            }),
        }),
        sendVerifyCode: builder.mutation({
            query: (data) => ({
                url: `sms-code`,
                method: 'POST',
                body: data,
            }),
        }),
        verifyCode: builder.mutation({
            query: (data) => ({
                url: `sms-code/verify`,
                method: 'POST',
                body: data,
            }),
        }),
        registerUser: builder.mutation({
            query: (data) => ({
                url: `customer`,
                method: 'POST',
                body: data,
            }),
        }),
        updatePassword: builder.mutation({
            query: (data) => ({
                url: `customer/changePsw/${data._id}`,
                method: 'PUT',
                body: { password: data.password, newPassword: data.newPassword },
            }),
        }),
        recoverPassword: builder.mutation({
            query: (data) => ({
                url: `password/request/customer`,
                method: 'POST',
                body: data,
            }),
        }),
        reactivateUser: builder.mutation({
            query: (data) => ({
                url: `api/v2/customer/reactivate/${data.email}`,
                method: 'PUT',
                body: data,
            }),
        }),
    }),
});

export const {
    useUpdateUserMutation,
    useValidateUsernameQuery,
    useLazyValidateUsernameQuery,
    useUpdateImgMutation,
    useVerifyEmailQuery,
    useLazyVerifyEmailQuery,
    useSendVerifyCodeMutation,
    useVerifyCodeMutation,
    useRegisterUserMutation,
    useUpdatePasswordMutation,
    useRecoverPasswordMutation,
    useReactivateUserMutation,
} = usersApi;